import { render, staticRenderFns } from "./chajiaoshuifei.vue?vue&type=template&id=1804f8b3&"
import script from "./chajiaoshuifei.vue?vue&type=script&lang=js&"
export * from "./chajiaoshuifei.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports